import { BaseExtension } from '../registry/extension';
/**
 * <zh/> 插件的基类
 *
 * <en/> Base class for plugins
 */
export class BasePlugin extends BaseExtension {
}
//# sourceMappingURL=base-plugin.js.map